// extracted by mini-css-extract-plugin
export var cancelButton = "_nr-5";
export var content = "_nr-3";
export var createButton = "_nr-6";
export var drawerContainer = "_nr-0";
export var footer = "_nr-2";
export var header = "_nr-1";
export var orderFormColumn = "_nr-4";